import { DinamikBilesen } from '@service/fikoyt-ui/decorators/dinamik-bilesen';
import { KartSahibiKartComponent } from './kart-sahibi-kart.component';
import { KartSahibiEditComponent } from './kart-sahibi-edit.component';

/**
 * Kart Sahibi / Kart Geçmişi — Dinamik Bileşen
 *
 * Görünümler:
 *  • paylas_kutusu     → bir kart okutulur, kime ait olduğu (isim) girilir
 *  • paylasilmis_kart  → o kartın ay bazlı okuma geçmişi (gün gün ilk/son
 *                         okuma; bir güne tıklanınca o güne ait tüm saatler)
 *
 * Personel/firma kaydı gerektirmez — takip tamamen tek bir kart UID'si
 * üzerinden yapılır (FikoYT.sistem.cihaz.olaylar / tip:'kart_koyuldu').
 */
@DinamikBilesen({
  id: 'hmi-kart-sahibi',
  baslik: 'Kart Sahibi / Kart Geçmişi',
  aciklama: 'Bir kartı okutup bir kişiye atar; paylaşılan kartta o kartın aylık okuma geçmişini gösterir',
  ikon: 'idcard',
  kategori: 'hmi',
  etiketler: ['nodemcu', 'rfid', 'nfc', 'kart', 'pdks', 'gecmis', 'devam'],
  oncelik: 11,
})
class HmiKartSahibiBilesen {
  paylasilmis_kart = KartSahibiKartComponent;
  paylas_kutusu    = KartSahibiEditComponent;
}
